import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AccountBudgetHistoryMatchParams,
  accountHistoryRouteProps,
} from 'src/navigation/routeProps'
import { GetBudgetRevisionsPagination } from 'src/redux/actions/data/budgetRevisions.actions'
import { RootState } from 'src/redux/createRootReducer'
import { selectBudgetRevisionListModelsFromState } from 'src/redux/selectors/data/budgetRevisions.selectors'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountBudgetHistoryMatchParams>(
      backgroundLocation.pathname,
      accountHistoryRouteProps,
    ) as match<AccountBudgetHistoryMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

const selectAccountRevisionIdsFromState = (state: RootState): string[] =>
  state.app.accountHistory.revisionIds

export const selectAccountRevisions = createSelector(
  [selectAccountRevisionIdsFromState, selectBudgetRevisionListModelsFromState],
  (revisionIds, revisions) => revisionIds.map((id) => revisions[id]),
)

export const selectFullyLoadedRevisionsFromState = (
  state: RootState,
): boolean => state.app.accountHistory.fullyLoadedRevisions

export const selectRevisionsLoadingFromState = (state: RootState): boolean =>
  state.app.accountHistory.revisionsLoading

export const selectRevisionsPaginationFromState = (
  state: RootState,
): GetBudgetRevisionsPagination => state.app.accountHistory.revisionsPagination
